// client/src/components/inbox/SavedRepliesPicker.jsx
//
// "Saved replies" menu for the Social Inbox reply box (Roadmap Phase 4).
// Picking one puts its text in the reply box, with {name} filled in from the
// message's author; the person can still edit before sending. Hidden when
// the tenant has no saved replies or the feature isn't set up yet.
// Saved replies are managed on the Inbox automation page.

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listSavedReplies, markSavedReplyUsed, fillName } from '../../services/inboxAutomationApi';

export default function SavedRepliesPicker({ tenantId, authorName, onInsert, disabled }) {
  const { t } = useTranslation();
  const [replies, setReplies] = useState([]);

  useEffect(() => {
    let live = true;
    if (tenantId) {
      listSavedReplies(tenantId)
        .then((r) => { if (live) setReplies(r.replies || []); })
        .catch(() => { if (live) setReplies([]); });
    }
    return () => { live = false; };
  }, [tenantId]);

  if (!replies.length) return null;

  const pick = (e) => {
    const id = Number(e.target.value);
    e.target.value = '';
    const r = replies.find((x) => x.id === id);
    if (!r) return;
    onInsert(fillName(r.body, authorName));
    markSavedReplyUsed(tenantId, r.id).catch(() => {});
  };

  return (
    <select
      aria-label={t('inboxAutomation.saved.pick', 'Insert a saved reply')}
      defaultValue=""
      onChange={pick}
      disabled={disabled}
      data-testid="saved-replies-picker"
      style={{
        background: '#1a1a2e', color: '#fff', border: '1px solid #444', borderRadius: 6,
        padding: '4px 8px', fontSize: '0.8rem', marginBottom: 6, maxWidth: '100%',
      }}
    >
      <option value="" style={{ background: '#1a1a2e', color: '#fff' }}>{t('inboxAutomation.saved.pickPlaceholder', 'Saved replies…')}</option>
      {replies.map((r) => (
        <option key={r.id} value={r.id} style={{ background: '#1a1a2e', color: '#fff' }}>{r.title}</option>
      ))}
    </select>
  );
}
